const Electricians = [
  {
    hideHeading: true,
  },
  {
    heading: 'Performance car tyres',
    description: `Originally designed for supercar racing, performance tyres are a popular choice among sports car enthusiasts. The reason being, they offer an enhanced driving experience, with a greater handling response. Built with specialised rubber compounds, performance car tyres enhance your vehicle’s responsiveness, traction and precision. Designed to handle the demands of the track, performance tyres provide greater maneuverability and control. This ensures they can stand up to the harshest weather conditions.`,
  },
  {
    heading: `All-season car tyres`,
    description: `As the name implies, this car tyre provides ideal traction in all weather conditions. A hybrid of winter and summer types, it combines the best features of each to create an extremely adaptable tyre. All-seasons are seemingly created specifically for the wildly varied Australian climate. They have the perfect mix of tread and traction to carry your vehicle effortlessly through all road surfaces, from bitumen, to dirt, to sand and everything in between.
<br><br>
    Be advised however, that all-seasons are not designed specifically for extreme conditions. So, it is the perfect combination of attributes if you live in an area which does not experience intense weather such as heavy snow or extreme heat.
    `,
  },
  {
    heading: `Mud tyres`,
    description: `These off-road tyres are the optimal choice for any weekend adventure. Whether you’re charging through mud in your 4WD or trekking through rocky terrain, mud tyres handle it all. With tread between 12mm-17mm, mud tyres are easy to spot. Mud tyres are the supreme off-road choice due to their large blocks (giving more tread to cut through any environment) and their ability to self-clean.

    `,
  },
  {
    heading: `Wet weather tyres`,
    description: `These are commonly found on high performance vehicles, such as sports cars. As their name suggests, this tyre is specifically designed to conquer wet conditions. With wide grooves, the water is pumped out to the rear of the vehicle. What truly distinguishes wet weather tyres is the revolutionary small cuts (AKA sipes). These give better grip on wet roads. Along with these, other wet weather tyres feature a V-shaped directional tread. It will automatically pump excess water out on an angle, and function as an anchor when the brakes are applied, for increased safety.`,
  },
  {
    heading: `Budget tyres`,
    description: `Just because these are cheap tyres, they are not inferior in any way. As replacing your tyres is one of most expensive aspects of car ownership, budget tyres are preferred by many Australians. There are many trusted brands with a range of hardy tyres for under $100 each. They are capable of handling even the most adverse weather and have a good grip.
    <br><br>
    When shopping for cheap tyres, there are certain features we recommend you look for, including:<br>
   <ul>
   <li>Its rating in wet weather.</li>
   <li>Good braking distance.</li>
   <li>Noise level.</li>
   <li>How its rates compared to more expensive tyres.</li></ul>
    `,
  },
  {
    tag: 'h2',
    heading: `How do I maintain my car tyres?`,
    description: `Australians have a love affair with the outdoors. Whether it’s a 4WD adventure, cruising around in a sports car or just getting from A to B, maintaining your car tyres is absolutely vital. Poor maintenance can increase the risk of accidents, increase wear and tear, decrease tread and more. Here are some simple maintenance tips to ensure your tyres are up to standard.`,
    faqs: [
      {
        tag: 'h3',
        q: `Check tyre pressure`,
        a: `Performing regular pressure checks will ensure your tyres handle well, steering remains optimal and increase the overall safety of your car. Not only that, but it makes the drive more comfortable, prolongs the lifespan of your tyres and maximises fuel economy.
<br><br>
        If you drive a lot, a good rule is to check your tyre pressure every week or two. However, if you don’t drive regularly, a handy way to remember is to check the pressure whenever you stop for petrol.
        <br><br>
        However, we recommend purchasing a tyre pressure gauge, as the air-pumps at petrol stations are not always 100% accurate. Inexpensive pen-shaped mechanical gauges are perfect. They don’t require a battery (making the reading reliable) and readily available from most car accessory stores.
        <br><br>
        Follow these simple steps to check your tyre pressure:
        <br>
       <ol>
       <li>Inspect the tyre placard. Found in your owner’s manual, it outlines the correct pressure for your car’s front and rear tyres.</li>
       <li>Unscrew the cap on the air valve.</li>
       <li>Place your tyre pressure gauge firmly into the tyre valve.</li>
       <li>Examine the pressure reading.</li>
       <li>If it’s too low, attach an air hose to increase the pressure to the right level. And;</li>
       <li>Screw the cap firmly back onto your tyre’s air valve.</li>
       </ol>
        `,
      },
      {
        tag: 'h3',
        q: `Rotate tyres`,
        a: `This is the periodic repositioning of your car’s tyres. An essential part of vehicle maintenance, we recommend rotating your tyres whenever you have your oil changed (or every 8,000 kilometres). Regular tyre rotation has many benefits. These include:
<br><ul>
        <li>Spreading wear evenly.</li>
        <li>Increasing tread life.</li>
        <li>Increasing tread depth.</li>
        <li>Improving cornering and brake performance.</li>
        </ul><br>
        However, the tyre rotation pattern you use depends on several factors, such as the kind of tyre you have, whether the front and rear tyres are the same size, whether they are directional or non-directional and whether your spare tyre is the same size as those on your vehicle.
        <br><br>
        As tyre sizes and types differ greatly, we recommend following your manufacturer’s recommendations. These can generally be found in your car’s handbook.
        `,
      },
      {
        tag: 'h3',
        q: `Check your tyre-load carrying limit`,
        a: `Are you going on a road trip with the family or helping a friend move house? If so, it’s essential to know exactly how much your tyres are able to carry. While many motorists don’t realise it, tyres aren’t typically designed to carry loads at all. That’s why knowing your tyre-load carrying limit is vital.
<br><br>
        However, calculating the exact weight your rims can handle is simple. You’ll find a two- or three-digit figure on your car’s registration paperwork or on the tyre’s sidewall. However, this number does not indicate the maximum weight in kilograms. To find out just how much you can carry, there are handy tyre rating load index tables on the Internet. This is particularly useful when buying tyres online.
        <br><br>
        Using the index is the simplest way to calculate the weight capacity of your tyres. When doing so, it’s important to keep tyre pressure in mind. The index assumes your tyre pressure is a standard 2.5 bar.
        <br><br>
        However, this pressure amount is not adhered to by most owners. And unfortunately, inadequate pressure can lead to poor driving habits. To prevent this, perform regular pressure checks and aim to increase it above the prescribed limit by a few tenths of a bar as needed.
        `,
      },
      {
        tag: 'h3',
        q: `Monitor your driving habits`,
        a: `How do you behave when you get behind the wheel? Are you cautious or do you tend to be a little careless? While it may sound surprising, your tyre wear is a clear indication of your driving style. Avoiding the following bad habits will lengthen the lifespan of your tyres and improve your driving skills.
        <br><br>
        <h4>Speeding</h4><br>
It may give you an adrenaline rush but speeding quickly wears down your tyres. At high speeds, tyres generate greater friction and overheat. Extended heat exposure softens the rubber and weakens the tyres.
<br><br>
<h4>Turning sharply</h4><br>
When you realise you’re about to miss a turn, you may take the corner too quickly. This will strip rubber from your tyres, wearing out the tread.
<br><br>
<h4>Driving over curbs and potholes</h4><br>
Ideally, all roads would be smooth and free of potholes. However, the road is filled with unpleasant hazards, such as potholes, gravel, glass and more. If you need to drive on uneven surfaces like these, drive slowly and carefully.
<br><br>
<h4>Braking harshly</h4><br>
You’ll have to stop suddenly sometimes, as you can’t control what other drivers do. However, you should ensure there’s plenty of distance when you apply the brakes. Otherwise, your tyres will wear out far too quickly.
`,
      },
      {
        tag: 'h3',
        q: `Book regular car services`,
        a: `Just like looking after your health, subjecting your car to regular servicing is essential. Finding a quality car repair near me ensures your vehicle is fuel efficient and running smoothly – and ultimately can save you thousands in repairs. Here are some vital reasons to book a regular car service:<br><br>
        <br> <h4>Prolong tyre life</h4><br>
Many motorists ask, “how long do tyres last?” This can vary, but it can be improved by ensuring they are well maintained.
<br><br>
<h4>Fuel efficiency</h4><br>
A properly tuned engine improves fuel economy, while reducing carbon emissions.
<br><br>
<h4>Prevent accidents</h4><br>
Ensuring there are no oil or fluid leaks will help you avoid a costly car repair.
<br><br>
<h4>Ensure roadworthiness</h4><br>
Having brakes adjusted and checked improves overall safety and guarantees roadworthiness for resale.
<br><br>
<h4>Decrease wear and tear</h4><br>
Properly lubricating all moving parts prevents general wear and tear.
`,
      },
    ],
  },
  {
    tag: 'h2',
    heading: `FAQ about Tyres in Australia`,
    faqs: [
      {
        tag: 'h3',
        q: `How much air pressure should I put in car tyres?`,
        a: `Correct air pressure is crucial to maintain tyre quality and good fuel economy. Every car has a recommended tyre pressure limit. Located on the driver’s side door, these specifications give your vehicle optimal performance, handling and tyre life. Generally, recommended tyre pressure is between 30 and 35 PSI. This figure represents the air pressure needed to support your car’s load-carrying capacity.
<br><br>
        Many people wonder how often they should adjust the air pressure in their tyres. Some useful guidelines to follow are: whenever you visit a petrol station or at the start of every month.
        `,
      },
      {
        tag: 'h3',
        q: `Can I fill car tyres with nitrogen?`,
        a: `For years, nitrogen has been used to fill tyres of aircraft, race cars and heavy commercial vehicles (i.e. trucks, etc.). Recently, however, it has been touted as a useful substance for car tyres. Those who promote the use of the colourless, odourless, non-toxic gas claim that it:
<br>
<ul>
        <li>Lowers the running temperature of tyres.</li>
        <li>Improves overall performance.</li>
        <li>Increases tyre lifespan.</li>
        <li>Supports a consistent tyre pressure.</li>
        <li>Slows pressure loss.</li>
        <li>Is compatible with tyres and rims.</li></ul>
        <br>
        Despite these apparent benefits, nitrogen does not replace tyre pressure maintenance and nitrogen is only beneficial when your tyres are operating at their maximum load and speed capacities.
        `,
      },
      {
        tag: 'h3',
        q: `How long do car tyres last?`,
        a: `There is no precise answer to this question. However, most manufacturers recommend replacing your tyres every 10 years. Remember, even if your tyres appear to be in good condition, they should be replaced once a decade from their manufacture date. The same is true for spare tyres.
        <br><br>
        Depending on the manufacturer and make of tyre, the exact distance you can travel before replacing them also varies. It’s generally between 10,000 and 50,000 kilometres.
        <br><br>
        However, these are general guidelines. The lifespan of car tyres can vary based on driving habits (i.e. frequency, and highway v. city driving), climate, the tyre’s design and make, road conditions and tyre maintenance.
        <br><br>
        If your tyres are five years old or more, they should be checked once a year. The reason is, after five years, they begin to deteriorate, dry out and lose significant traction. This happens regardless of how far you drive. A handy way to remember is to have them checked as part of your general car service. Or, if not, have them looked at by a tyre specialist.
        `,
      },
      {
        tag: 'h3',
        q: `How much do tyres cost in Australia?`,
        a: `When purchasing a new or used car, one of the first questions motorists ask is “how much do tyres cost?”
<br><br>
        Much like vehicles, tyre prices can vary widely. That’s why it’s important to do proper research before heading in to a tyre shop near me. There is a wide variety of cheap tyres available (with prices ranging from $79 to $95 each). However, there are also more costly brands, catering for larger or more expensive vehicles. Ultimately though, the cost of your tyres will depend on the tyre shop, the brand, size and the type of tyre you need.
        <br><br>
        To make the dearer brands more accessible, some stores will have a tyre sale, or even allow you to purchase tyres with Afterpay.
        `,
      },
      {
        tag: 'h3',
        q: `Can tyres be recycled in Australia?        `,
        a: `Yes. <a target="_blank" href="https://www.tyrestewardship.org.au/">Tyre Stewardship Australia (TSA)</a> is committed to reducing the harm caused by illegal tyre dumping. The TSA is comprised of representatives across the tyre supply chain, such as retailers, manufacturers, collectors and recyclers.
        <br><br>
        By recycling end-of-life tyres, they are transformed into useful commodities while also creating employment opportunities and developing new industries.

        `,
      },
      {
        tag: 'h3',
        q: `What should I do if I have a flat tyre?`,
        a: `If possible, we recommend consulting a mechanic at an auto shop near me. Otherwise, simply follow these steps:
      <br><ul>  <li>Remove the wheel cover.</li>
        <li>Loosen the lug nuts by turning them counterclockwise.</li>
        <li>Lift the flat tyre with a jack (about 30cm).</li>
        <li>Remove lug nuts.</li>
        <li>Grab the tyre, pulling it towards you until removed.</li>
        <li>Insert the spare tyre, ensuring the rim and lug nuts are aligned.</li>
        <li>Tighten the lug nuts.</li>
        <li>Lower your car, removing the jack.</li>
        <li>Ensure your spare tyre has correct pressure</li></ul>
        `,
      },
      {
        tag: 'h3',
        q: `Are tyres checked during a regular car service?`,
        a: `Good tyres are essential to your car’s longevity and overall performance. As such, a thorough inspection of tyre quality is a crucial part of any car service. A mechanic will check to ensure your tyres are at the correct pressure, wear and depth are stable and that your spare tyre is in proper working order.
<br><br>
        Usually performed every 12 months, a quality service will – assure you you’re receiving expertise and genuine parts, and give you a record of your car’s service history. This is useful if you plan to sell your car in future.
        `,
      },
      {
        tag: 'h3',
        q: `How can I tell when I need new tyres?`,
        a: `Your tyres are literally what separates you from the road. So, they can take quite a beating, even with normal wear and tear. Despite this, many people neglect to check their tyre health regularly. Thankfully, there are some simple ways to determine when they need to be replaced.
        <br><br>
        Tread depth – This should be no lower than 1.6mm. If you regularly drive on wet surfaces, the tread depth should be twice that amount. Most tyres have tread wear indicator bars to remind you. If you can see more than two bars, it’s time to visit an auto shop near me for replacement tyres.
        <br><br>
        Leaks – These can appear in the tyre’s side wall. To spot them, simply look for noticeable marks. Cracked or worn out sidewalls indicate that your tyres are leaking and may blow at any time.
        <br><br>
        Vibration – If you’re an experienced driver, you’ll know the difference between regular vibrations and problems. Irregular vibrations may indicate misaligned or unbalanced tyres. In some cases, it may also signal internal tyre problems. Whatever the cause, head to a car repair shop right away.
        `,
      },
      {
        tag: 'h3',
        q: `Does Australia have tyre safety standards?`,
        a: `Yes. In 1950, tyre, wheel and rim manufacturers established the Tyre and Rim Association of Australia. Its key goals are:
        <br>
        <ul>
        <li>To promote discussion of issues in the automotive industry.</li>
        <li>To improve technical knowledge of car enthusiasts.</li>
        </ul>
        <br>
        The TRAA provides clear automotive industry standards, current research on car safety and maintenance and up-to-date resources for car owners and industry members. Each year, the TRAA releases a Standards Manual. The 2020 edition features new tyre sizes, tyre size selection, performance and application. It’s a vital resource for everyone involved with or interested in tyres and rims.
        `,
      },
      {
        tag: 'h3',
        q: `Should I replace all tyres at once?`,
        a: `Many mechanics recommend replacing all four tyres at the same time, for several reasons. Firstly, if you only replace your front or back tyres, you may forget about the others. This can increase the likelihood of treadwear. Secondly, it’s difficult to find new tyres with the same tread as older ones. And, thirdly, as tread wears in older tyres, traction grows worse, making it harder to turn in wet weather.

        `,
      },
    ],
  },
];

export default Electricians;
